import stripeClient from "../networkClients/stripe-client";

const requestCustomerPortalSession = async (customerId: string | undefined) => {
    try {
        const body: {} = {
            "action"     : "create-customer-portal-session",
            "customer_id": customerId,
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const requestCheckoutSession = async (userEmail: string, customerId: string | undefined) => {
    try {
        const body: {} = {
            "customer_email": userEmail,
            "action"        : "create-checkout-session",
            "customer_id"   : customerId,
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const retrieveCheckoutStatus = async (sessionId: string) => {
    try {
        const body: {} = {
            "session_id": sessionId,
            "action"    : "retrieve-checkout-session-status",
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const fetchListCustomerSubscriptions = async (customer_id: string) => {
    try {
        const body: {} = {
            "customer_id": customer_id,
            "action"     : "list_customer_subscriptions",
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const createCustomerPortalSession = async (userEmail: string) => {
    try {
        const body: {} = {
            "customer_email": userEmail,
            "action"        : "create-customer-portal-session",
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}


const StripeService = {
    requestCheckoutSession, createCustomerPortalSession, retrieveCheckoutStatus, fetchListCustomerSubscriptions,
    requestCustomerPortalSession
}
export default StripeService;